<div (click)="sendClose()" class="absolute left-0 top-0 opacity-30 h-full w-screen bg-black"></div>

<div
  class="absolute max-[642px]:bottom-0 max-[642px]:left-0 bg-white max-[642px]:rounded-t-2xl min-[643px]:rounded-2xl max-[643px]:w-full min-[643px]:w-[610px] min-[643px]:m-auto min-[643px]:top-1/2 min-[643px]:-translate-y-1/2"
>
  <div class="flex flex-col">
    <img
      (click)="sendClose()"
      class="mt-5 mr-4 self-end cursor-pointer"
      src="../../../../assets/images/svg/cross-close.svg"
    />
  </div>
  <ng-content></ng-content>
</div>
